import React from "react";
import { useDimensions } from "../Util";
import AddictionsContainer from "./AddictionsContainer/AddictionsContainer";
import WalletAndMotivationContainer from "./WalletAndMotivationContainer/WalletAndMotivationContainer";
import MoneyContainer from "./MoneyContainer/MoneyContainer";
import TimeContainer from "./TimeContainer/TimeContainer";
import { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdsContainer from "./AdsContainer/AdsContainer";
import ActsContainer from "./ActsContainer/ActsContainer";
import DeveloperNote from "./DeveloperNote";

const LandingPage = () => {

    const { w, h } = useDimensions();
    const fr = w>h?w/h:h/w;
    const navigate = useNavigate();
    const [incompatablescreen,setIncompatibleScreen] = useState(false);
    const [showDeveloperNote,setShowDeveloperNote] = useState(false);
    const [proaddictiveUser,setProaddictiveUser] = useState(JSON.parse(sessionStorage.getItem("proaddictive-user"))||JSON.parse(localStorage.getItem("proaddictive-user")));
    const [token,setToken]=useState(JSON.parse(sessionStorage.getItem("bearer-token"))||JSON.parse(localStorage.getItem("bearer-token")));

    useEffect(() => {
        if(100*w>800){
            if(100*h<650){
                setIncompatibleScreen(true)
            }
        }
        else if(100*w<375||100*h<375){
            setIncompatibleScreen(true)
        }
        else{
            setIncompatibleScreen(false)
        }
        
        const hasSeenDeveloperNote = localStorage.getItem("hasSeenDeveloperNote");

        if (!hasSeenDeveloperNote) {
            // Show the note after 2 seconds
            const timer = setTimeout(() => {
                setShowDeveloperNote(true);
                localStorage.setItem("hasSeenDeveloperNote", "true"); // Store the flag
            }, 2000);
        return () => clearTimeout(timer); // Cleanup timeout on unmount
        }

    }, [w, h]);

    const landingPage = {
        width: "100%",
        height: "100%",
        display: "grid",
        gridTemplateRows: w > h ? "repeat(50, 1fr)" : "repeat(50, 1fr)",
        gridTemplateColumns: w > h ? "repeat(50, 1fr)" : "repeat(50, 1fr)",
        gap: "7px"
    }

    const addictionsData = [
        { id: 'smoking', image: '1-grey-smoke.png', text: 'Smoking', tagLine: 'Smoking is dangerous',penalty:5,punishment:15,question:"Did you Smoke today ?",type:"general"},
        { id: 'drinking', image: '2-grey-beer.png', text: 'Drinking', tagLine: 'Alcohol is Evil',penalty:15,punishment:25,question:"Did you Drink today ?",type:"general" },
        { id: 'breakup', image: '3-grey-breakup.png', text: 'Breakup', tagLine: 'Breakups are worst',penalty:5,punishment:10,question:"Did you think about your ex today ?",type:"general" },
        { id: 'addnew', image: '5-grey-add-your-own.png', text: 'Add New', tagLine: 'Add Your Own Problem',penalty:5,punishment:5,question:"Go Ahead and add your own thing",type:"comingsoon" },
        { id: 'junkfood', image: '4-grey-junkfood.png', text: "Junk Food", tagLine: 'Junk Food Makes you sick',penalty:10,punishment:40,question:"Did you eat any junk food today?",type:"general" },
        { id: 'scrolling', image: '6-grey-scrolling.png', text: "Scrolling", tagLine: 'Scrolling is not 5mins it will stay long',penalty:15,punishment:5,question:"Had spent any time on scrolling today?",type:"general" },
        { id: 'private', image: '7-grey-private.png', text: "Private", tagLine: 'Want to keep it private? We never mind',penalty:10,punishment:10,question:"Want to keep it private? Its Ok",type:"comingsoon" },
    ];

    const actsData = [
        {id:'read-and-let-read',image:'read-and-let-read.png',text:'Read And Let Read',type:'time',value:'15'},
        {id:'penny-stocks',image:'penny-stocks.png',text:'Penny Stocks',type:'money',value:'5'},
        {id:'read-and-review',image:'read-and-review.png',text:'Read And Review',type:'time',value:'25'},
        {id:'gold-bonds',image:'gold-bonds.png',text:'Gold Bonds',type:'money',value:'25'},
        {id:'crypto-currencies',image:'crypto-currency.png',text:'Crypto Currencies',type:'money',value:'10'},
        {id:'random-recipie',image:'random-recepie.png',text:'Random Recipie',type:'time',value:'40'},
        {id:'mutual-funds',image:'mutual-funds.png',text:'Mutual Funds',type:'money',value:'15'},
        {id:'make-new-friend',image:'make-new-friend.png',text:'Make A New Friend',type:'time',value:'10'},
        {id:'fixed-deposit',image:'fixed-deposit.png',text:'Fixed Deposit',type:'money',value:'50'},
        {id:'sport-buddy',image:'sport-buddy.png',text:'Sport Buddy',type:'time',value:'60'},
        {id:'alternate-gambling',image:'alternate-gambling.png',text:'Alternate Gambling',type:'money',value:'5'},
        {id:'express-thoughts',image:'express-thoughts.png',text:'Express Thoughts',type:'time',value:'10'},
        {id:'knowledge-bytes',image:'knowledge-bytes.png',text:'Knowledge Bytes',type:'time',value:'5'},
        {id:'coder-steps',image:'coder-steps.png',text:'Coder Steps',type:'time',value:'10'},

    ];

    return <div id="landing-page" style={landingPage}>
        <AddictionsContainer addictionsData={addictionsData}></AddictionsContainer>
        <WalletAndMotivationContainer walletBalance={proaddictiveUser?.walletbalance}></WalletAndMotivationContainer>
        <MoneyContainer jarBalance={proaddictiveUser?.jarbalance} penaltyOwe={proaddictiveUser?.jarowe}></MoneyContainer>
        <TimeContainer clockBalance={proaddictiveUser?.clockbalance} punishmentOwe={proaddictiveUser?.clockowe}></TimeContainer>
        <AdsContainer></AdsContainer>
        <ActsContainer actsData={actsData}></ActsContainer>
        
        {incompatablescreen && (
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    background: "#393E46",
                    padding: "20px",
                    borderRadius: "8px",
                    width: w > h ? "40%" : "85%",
                    height: w > h ? "50%" : "50%",
                    border: "6px solid #00ADB5"
                }}
            >

                <p>INCOMPATIBLE SCREEN SIZE</p>
                <p>MOVE BACK TO YOUR ORIGINAL SCREEN SIZE</p>
            </div>
        )}

        {/* Overlay */}
        {incompatablescreen && (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 999,
                    background: "rgba(0, 0, 0, 0.5)",
                }}
            ></div>
        )}

{showDeveloperNote && (
            <div
                style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    zIndex: 1000,
                    background: "#393E46",
                    padding: "20px",
                    borderRadius: "8px",
                    width: w > h ? "70%" : "85%",
                    height: w > h ? "65%" : "75%",
                    border: "6px solid #00ADB5"
                }}
            >

                <DeveloperNote showDevNote={setShowDeveloperNote}></DeveloperNote>
            </div>
        )}

        {/* Overlay */}
        {showDeveloperNote && (
            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    zIndex: 999,
                    background: "rgba(0, 0, 0, 0.5)",
                }}
            ></div>
        )}

    </div>
}

export default LandingPage;